export default __webpack_public_path__ + "core-logo-transparent.452dd594.png";